import { PositionType } from '@/types'
import { createFileRoute } from '@tanstack/react-router'

import { CredenzaBody, CredenzaContent } from '@/components/ui/credenza'
import EditPositionForm from '@/components/forms/edit-position-form'

export const Route = createFileRoute(
  '/_home/user-role-management/position/edit',
)({
  component: () => <div>Hello /_home/user-role-management/position/edit!</div>,
})

export default function EditPositionPage({
  positionData,
  setShowEditModal,
}: {
  positionData: PositionType
  setShowEditModal: React.Dispatch<React.SetStateAction<boolean>>
}) {
  return (
    <main>
      <CredenzaContent className="flex w-full max-w-2xl justify-center">
        <CredenzaBody>
          <EditPositionForm
            positionData={positionData}
            setShowEditModal={setShowEditModal}
          />
        </CredenzaBody>
      </CredenzaContent>
    </main>
  )
}
